import React, { useEffect, useState } from 'react';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import { useHistory, useLocation } from 'react-router-dom';
import { List, ListItem } from '@mui/material';

export function PanelHeader({ user }) {
    const { name, email } = user || {}
    return <div>
        <p style={{display: "flex", justifyContent: "center"}}><b>{name}</b></p>
        <p style={{display: "flex", justifyContent: "center"}}>{email}</p>
    </div>
}
export function FixedPanel({ setSidePanel, logout, tertiary }) {
    let [activeKey, setActiveKey] = useState<string>("");
    let history = useHistory();
    let location = useLocation();
    const options =
        [{
            name: "Home",
            icon: <HomeIcon style={{ marginRight: "5px" }} />,
            selected: "account",
            hidden: false
        },
        {
            name: "Make Payment",
            icon: <AttachMoneyIcon style={{ marginRight: "5px" }} />,
            selected: "payment",
            hidden: false
        },
        {
            name: "History",
            icon: <FormatListBulletedIcon style={{ marginRight: "5px" }} />,
            selected: "history",
            hidden: false
        },
        {
            name: "Wallet",
            icon: <CreditCardIcon style={{ marginRight: "5px" }} />,
            selected: "wallet",
            hidden: false
        },
        {
            name: "Manage Account",
            icon: <PersonIcon style={{ marginRight: "5px" }} />,
            selected: "manage",
            hidden: false
        },
        {
            name: "Sign Out",
            icon: <ExitToAppIcon style={{ marginRight: "5px" }} />,
            hidden: false
        }];

    useEffect(() => {
        setActiveKey(location.pathname.split("/")[1] === "sign-in" ? "account" : location.pathname.split("/")[1]);
    }, [location])// eslint-disable-line react-hooks/exhaustive-deps

    const handleSelect = option => {
        setSidePanel && setSidePanel("offcanvas-collapse");
        setActiveKey(option.selected)
        switch (option.name) {
            case "Home":
                history.push('/account');
                break;
            case "Manage Account":
                history.push('/manage');
                break;
            case "History":
                history.push('/history');
                break;
            case "Make Payment":
                history.push('/payment');
                break;
            case "Wallet":
                history.push("/wallet");
                break;
            case "Sign Out":
                logout();
                break;
        }
    }
    return (
        <List>
            {options.map((option) => {
                if(option.hidden) return null;
                return (
                    <ListItem
                        key={option.selected}
                        onClick={() => handleSelect(option)}
                        style={{ border: "none", backgroundColor: activeKey === option.selected ? tertiary : "", color: activeKey === option.selected ? "white" : "black" }}
                        className={"clickable"}>
                        {option.icon}
                        {option.name}
                    </ListItem>)
            })}
        </List>)
}